export default __webpack_public_path__ + "2317e5dc4dc1f58a26febae5a1c8a455.svg";